var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_96_2661)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.7967 -0.000976562C8.58732 0.00144977 6.46911 0.880203 4.90684 2.44248C3.34456 4.00476 2.46581 6.12296 2.46338 8.33236C2.46338 12.734 9.46338 18.7765 10.2584 19.4515L10.7967 19.9065L11.335 19.4515C12.13 18.7765 19.13 12.734 19.13 8.33236C19.1276 6.12296 18.2489 4.00476 16.6866 2.44248C15.1243 0.880203 13.0061 0.00144977 10.7967 -0.000976562ZM10.7967 12.499C9.97262 12.499 9.16704 12.2547 8.48184 11.7968C7.79663 11.339 7.26258 10.6882 6.94721 9.92687C6.63185 9.16551 6.54934 8.32773 6.71011 7.51948C6.87088 6.71123 7.26772 5.9688 7.85043 5.38608C8.43315 4.80336 9.17558 4.40652 9.98384 4.24575C10.7921 4.08498 11.6299 4.16749 12.3912 4.48286C13.1526 4.79822 13.8033 5.33228 14.2612 6.01748C14.719 6.70269 14.9634 7.50827 14.9634 8.33236C14.9621 9.43702 14.5226 10.4961 13.7415 11.2772C12.9604 12.0583 11.9014 12.4977 10.7967 12.499Z",
    fill: "#EE4E56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7969 10.832C12.1776 10.832 13.2969 9.71274 13.2969 8.33203C13.2969 6.95132 12.1776 5.83203 10.7969 5.83203C9.41616 5.83203 8.29688 6.95132 8.29688 8.33203C8.29688 9.71274 9.41616 10.832 10.7969 10.832Z",
    fill: "#EE4E56"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_96_2661"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.796875 -0.000976562)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location-icon.f4257cc01e0c91d77c74a24091806191.svg";
export { ForwardRef as ReactComponent };